import { css, keyframes } from '@emotion/react';
import { Colors } from '../common/Colors';
import { helperAbsoluteFill } from './absoluteFill';

const shineBox = keyframes`
  to {
    background-position: 200% center;
  }
`;

export const helperLoadingBox = (
  bgColor: string,
  gradientColor: string = Colors.ut.transparent
) => css`
  position: relative;

  &:before {
    ${helperAbsoluteFill};
    content: '';
    pointer-events: none;
    z-index: 20;
    background-image: linear-gradient(to left, ${bgColor}, ${gradientColor} 50%, ${bgColor});
    background-size: 200% auto;
    animation: ${shineBox} 1s linear infinite;
  }
`;
